import {
    permissionActions,
    permissionThunks as defaultThunks,
    permissionSelectors as defaultSelectors,
    permissionReducer,
} from './Permission-slice';
import * as thunks from './Permission-thunks';
import * as selectors from './Permission-selectors';

const permissionThunks = { ...defaultThunks, ...thunks };
const permissionSelectors = { ...defaultSelectors, ...selectors };

export { permissionSelectors, permissionActions, permissionThunks, permissionReducer };
